import { hasGlobalRole } from './hasGlobalRole';

const canWhiteLabel = auth => {
  return hasGlobalRole('owner')(auth) && auth.platform.is_white_label;
};

export default canWhiteLabel;
